import styled from 'styled-components';

interface WrapperProps {}

export const Wrapper = styled.article<WrapperProps>`
  display: flex;
  flex-direction: column;
`;

export const Top = styled.div`
  margin-bottom: 20px;
`;
